module.exports = __webpack_public_path__ + "img/compressed.88af98ab.jpg";